import React from "react";

const UncodedMedical = () =>{
  return(
    <div className="bg-white max-w-[460px] text-teal-300 text-body-sm">
      <div>
        <h3 className="font-bold p-3">
          This is an UNCODED Medical Type.
        </h3>
      </div>
      <div>
        <p className="p-3">
          No Clinical Analysis will be performed
        </p>
      </div>
    </div>
  );
};

export default UncodedMedical;